export default __webpack_public_path__ + "static/media/dropdown-up.b69f0805.svg";